import { useSettings } from "@/composables/useSettings";
const BACKEND_BASE_URL = "https://maps.jakarto.com";

export type Sphere = {
  image_id: string;
  date: Date;
  x: number;
  y: number;
  z: number;
  heading: number;
  pitch: number;
  roll: number;
  z_offset: number;
};

const settings = useSettings();

async function backendFetch(
  input: string,
  init?: RequestInit
): Promise<Response> {
  const url = prefixBackendUrl(input);

  let finalInit: RequestInit = init ?? {};

  finalInit = {
    ...finalInit,
    headers: {
      ...finalInit.headers,
      ...backendFetchParams().headers,
    },
    credentials: backendFetchParams().credentials,
  };

  return fetch(url, finalInit);
}

function backendFetchParams(): RequestInit {
  const apiKey = settings.getString("VITE_JAKARTO_API_KEY", undefined);
  if (apiKey !== undefined) {
    // in dev
    return {
      headers: {
        Authorization: `apikey ${apiKey}`,
      },
      credentials: "same-origin",
    };
  }
  // in prod
  return {
    headers: {},
    credentials: "include",
  };
}

function prefixBackendUrl(input: string): string {
  if (input.startsWith("http")) return input;
  const path = input.startsWith("/") ? input : `/${input}`;
  return `${BACKEND_BASE_URL}${path}`;
}

export { backendFetch, backendFetchParams, BACKEND_BASE_URL };
